// removed by extract-text-webpack-plugin
module.exports = {"Order":"Order__Order__W-Npf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/Order.css
// module id = 147
// module chunks = 0